import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'

import { AggregationAnalysisFacade } from '~/core/features'
import { MetaTagService } from '~/core/services'

export const aggregationAnalysisQuarterDataResolver: ResolveFn<void> = () => {
  inject(MetaTagService).setQuarterlyDashboardPageMeta()

  return inject(AggregationAnalysisFacade).getAggregationAnalysisQuarterData()
}
